module.exports = __webpack_public_path__ + "static/media/eliza.41f2dd7e.jpg";